import http from "@/apis/http";
import url from "@/config/url";

const reward = url.tgBusiness.member.reward;

export default {
  getColumns: (params) => {
    return http.post(reward.columns, params);
  },
  getData: (params) => {
    return http.post(reward.search, params);
  },
  getGames: (params) => {
    return http.post(reward.games, params);
  },
  getDetail: (params) => {
    return http.post(reward.detail, params);
  },
};
